import ChatRoutes from "src/routes/authenticated/chat";
import CreditsRoutes from "src/routes/authenticated/credits";
import DashboardRoutes, {
	DashboardModalRoutes,
} from "src/routes/authenticated/dashboard";
import EnvelopeRoutes from "src/routes/authenticated/envelopes";
import LanguageRoutes from "src/routes/authenticated/language";
import NetworkRoutes from "src/routes/authenticated/network";
import OffersRoutes from "src/routes/authenticated/offers";
import PaymentsRoutes from "src/routes/authenticated/payments";
import ProfileRoutes, {
	ProfileModalRoutes,
} from "src/routes/authenticated/profile";
// import ReferralRoutes from "src/routes/admin/referral";
import ReviewsRoutes from "src/routes/authenticated/reviews";
import SettingsRoutes from "src/routes/authenticated/settings";
import SignerRoutes from "src/routes/authenticated/signer";
import SubscriptionRoutes from "src/routes/authenticated/subscription";
import TalentsRoutes from "src/routes/authenticated/talents";
import TasksRoutes, { TasksModalRoutes } from "src/routes/authenticated/tasks";
import AuthRoutes from "src/routes/auth";
import HoursRoutes from "src/routes/authenticated/hours";
import GlobalRoutes from "src/routes/global";
import NotFoundView from "src/views/auth/NotFoundView";
import { Route, Routes as ReactRoutes, useLocation } from "react-router-dom";
import FeedbackRoutes, {
	FeedbackModalRoutes,
} from "src/routes/authenticated/feedback";

interface RoutesProps {
	children?: any;
}

const Routes = ({ children }: RoutesProps) => {
	const location = useLocation() as any;
	const background = location.state ? location?.state?.background : false;

	const ROUTES = [
		...GlobalRoutes,
		...AuthRoutes,
		...ChatRoutes,
		...CreditsRoutes,
		...DashboardRoutes,
		...EnvelopeRoutes,
		...NetworkRoutes,
		...PaymentsRoutes,
		...ProfileRoutes,
		...ReviewsRoutes,
		...SettingsRoutes,
		...SubscriptionRoutes,
		...TasksRoutes,
		...SignerRoutes,
		...OffersRoutes,
		...TalentsRoutes,
		...LanguageRoutes,
		...HoursRoutes(),
		...FeedbackRoutes,
	];

	return (
		<>
			<ReactRoutes location={background || location}>
				{ROUTES}
				<Route path="*" key="not-found" element={<NotFoundView />} />
			</ReactRoutes>
			{children}

			{background && (
				<ReactRoutes>
					{DashboardModalRoutes}
					{TasksModalRoutes}
					{ProfileModalRoutes}
					{FeedbackModalRoutes}
				</ReactRoutes>
			)}
		</>
	);
};

export default Routes;
